import {Events} from "backbone";

// TODO use window.dispatchEvent(new CustomEvent("eventname", {})) instead (but what about garbage collection phantom views?) -> https://developer.mozilla.org/en-US/docs/Web/API/CustomEvent/CustomEvent
// http://backbonejs.org/#Events-trigger
// https://stackoverflow.com/questions/16823746/backbone-js-listento-vs-on
export default Object.create(Events);
